<script setup lang="ts">
    import { computed, toRef } from 'vue'
    import { tchMarked } from '@common/Common'

    import type { AlternativeDetailsDialogViewModel } from '@Alternatives/Alternatives/Components/AlternativeDetailsDialog'

    // ---------------- props ----------------

    const props = defineProps<{
        viewModel: AlternativeDetailsDialogViewModel
    }>()

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- computed ----------------

    const opened = computed(() => vm.value?.opened ?? false)
    const name = computed(() => vm.value.name)
    const description = computed(() => vm.value.description)
    const descriptionHtml = computed(() =>
        description.value ? tchMarked(description.value) : null
    )
    const detailsUrl = computed(() => vm.value.detailsUrl)

    // ---------------- actions ----------------

    function close()
    {
        vm.value.close()
    }
</script>


<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-xl modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{name}}​</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>

                    <div class="modal-body">
                        <p v-if="!description" class="text-muted font-italic lead">No description provided</p>
                        <div v-html="descriptionHtml"></div>
                    </div>

                    <div class="modal-footer">
                        <a v-if="detailsUrl" v-sanitizedHref="detailsUrl" target="_blank" class="btn btn-success">Details</a>
                        <button @click="close" type="button" class="btn btn-outline-secondary">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
